import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="font-serif text-8xl text-champagne">404</p>
      <h1 className="font-serif text-3xl text-espresso mt-4">Page Not Found</h1>
      <p className="text-espresso/50 mt-3">The page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-8 bg-espresso text-ivory px-10 py-3.5 rounded-full text-sm">Back to Home</Link>
    </div>
  );
}
